<nav class="navbar horizontal-layout col-lg-12 col-12 p-0" *ngIf="permission && !isLoginPage">
    <div class="nav-bottom">
      <div class="container-fluid d-flex align-items-center">
        <div class="navbar-brand-wrapper d-flex align-items-center mr-3">
          <a class="navbar-brand brand-logo" routerLink="/pages/home"><img src="/assets/images/3bc-logo-new.jpeg" alt="logo"/></a>
          <a class="navbar-brand brand-logo-mini" routerLink="/pages/home"><img src="/assets/images/3bc-logo-new.jpeg" alt="logo"/></a>
        </div>
        <ul class="nav page-navigation d-flex align-items-center flex-grow-1" [ngClass]="{'nav-open': isNavMenuOpen}">
          <button class="close-nav-btn" (click)="toggleNavMenu()" *ngIf="isNavMenuOpen">×</button>
          <li class="nav-item">
            <a routerLink="/pages/home" class="nav-link" routerLinkActive="current"><i class="link-icon icon-screen-desktop"></i><span class="menu-title">Dashboard</span></a>
          </li>
          <li class="nav-item" *ngIf="permission.diary > 0">
            <a [routerLink]="userType.userTypeId == 2 ? '/pages/barrister-diary' : '/pages/diary'" class="nav-link" routerLinkActive="current"><i class="link-icon icon-calculator"></i><span class="menu-title">Diary</span></a>
          </li>
          <li class="nav-item" >
            <a routerLink="/pages/cases" class="nav-link" routerLinkActive="current"><i class="link-icon icon-book-open"></i><span class="menu-title">Cases</span><i class="menu-arrow"></i></a>
            <div class="submenu">
              <ul class="submenu-item">
                <li class="nav-item" *ngIf="userType.userTypeId == 1"><a class="nav-link" routerLink="/pages/cases/case/new">New Case</a></li>
                <li class="nav-item" ><a class="nav-link" routerLink="/pages/cases/upcoming">Upcoming Cases</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/pages/cases/past">Past Cases</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/pages/cases/all">All Cases</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" *ngIf="permission.solicitorFirm > 0 && userType.userTypeId == 1">
            <a routerLink="/pages/solicitors" class="nav-link" routerLinkActive="current"><i class="link-icon icon-disc"></i><span class="menu-title">Solicitors</span><i class="menu-arrow"></i></a>
            <div class="submenu">
              <ul class="submenu-item">
                <li class="nav-item"><a class="nav-link" routerLink="/pages/solicitors/new">New Solicitor</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/pages/solicitors">Solicitors</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" *ngIf="permission.barrister > 0 && userType.userTypeId == 1">
            <a routerLink="/pages/barristers" class="nav-link" routerLinkActive="current"><i class="link-icon icon-disc"></i><span class="menu-title">Barristers</span><i class="menu-arrow"></i></a>
            <div class="submenu">
              <ul class="submenu-item">
                <li class="nav-item"><a class="nav-link" routerLink="/pages/barristers/barrister">New Barrister</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/pages/barristers">Barristers</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" *ngIf="(permission.client > 0 && userType.userTypeId == 1) || (permission.conferrence > 0 && userType.userTypeId == 1)">
            <a routerLink="/pages/clients" class="nav-link" routerLinkActive="current"><i class="link-icon icon-wallet"></i><span class="menu-title">Clients</span><i class="menu-arrow"></i></a>
            <div class="submenu">
              <ul class="submenu-item">
                <li class="nav-item" *ngIf="permission.client > 0 && userType.userTypeId == 1"><a class="nav-link" routerLink="/pages/clients">DPA Clients</a></li>
                <li class="nav-item" *ngIf="permission.conferrence > 0 && userType.userTypeId == 1"><a class="nav-link" routerLink="/pages/meetings">Conference</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" *ngIf="permission.task > 0">
            <a routerLink="/pages/tasks" class="nav-link" routerLinkActive="current"><i class="link-icon icon-wallet"></i><span class="menu-title">Tasks</span></a>
          </li>
          <li class="nav-item" *ngIf="permission.invoice > 0 && userType.userTypeId == 1">
            <a routerLink="/pages/financial/" class="nav-link" routerLinkActive="current"><i class="link-icon icon-disc"></i><span class="menu-title">Financial</span><i class="menu-arrow"></i></a>
            <div class="submenu">
              <ul class="submenu-item">
                <li class="nav-item"><a class="nav-link" routerLink="/pages/financial/solicitor">Solicitor Statement</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/pages/financial/dpaclient">DPA Statement</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/pages/financial/barrister">Barrister Statement</a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item" *ngIf="permission.report > 0 && userType.userTypeId == 1">
            <a routerLink="/pages/report/" class="nav-link" routerLinkActive="current"><i class="link-icon icon-disc"></i><span class="menu-title">Report</span><i class="menu-arrow"></i></a>
            <div class="submenu">
              <ul class="submenu-item">
                <li class="nav-item"><a class="nav-link" routerLink="/pages/report/solicitor">Solicitor Report</a></li>
                <li class="nav-item"><a class="nav-link" routerLink="/pages/report/barrister">Barrister Report</a></li>
              </ul>
            </div>
          </li>
        </ul>
        <button class="close-nav-btn" (click)="toggleNavMenu()" *ngIf="isNavMenuOpen">×</button>
        <div class="d-flex align-items-center mr-2" *ngIf = "userType.userTypeId == 1">
          <button class="search-toggle-btn" type="button" (click)="toggleSearch()" [class.active]="isSearchOpen">
            <span class="input-group-text"><i class="icon-magnifier"></i></span>
          </button>
          <div class="search-dropdown-container">
            <div *ngIf="isSearchOpen" class="search-dropdown">
              <div class="form-group">
                <input #searchInput type="text" name="filter" id="filter" class="form-control" placeholder="{{placeholder}}" [(ngModel)]="searchData.filter" (keyup)="onSearchInput($event)">
              </div>
              <div class="form-group">
                <select name="tableName" class="form-control" id="tableName" [(ngModel)]="searchData.tableName" (change)="updatePlaceholder()">
                  <option value="cases">Cases</option>
                  <option value="invoice">Invoice</option>
                  <option value="barristers">Barristers</option>
                  <option value="solicitorCompany">Solicitor Firm</option>
                  <option value="clients">DPA Clients</option>
                </select>
              </div>
              <button class="close-btn" type="button" (click)="closeSearch()">
                <span class="input-group-text"><i class="icon-close"></i></span>
              </button>

              <!-- Search Results Auto-complete - positioned below search inputs -->
              <ul class="auto-complete" *ngIf="models">
                <li *ngFor="let model of models">
                  <a (click)="navigate(model.modelLink)" class="no-link" style="color: #625530;">{{model.modelTitle}}</a>
                  <span>{{model.modelDetails}}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="ml-auto d-flex align-items-center">
          <ul class="navbar-nav">
            <li class="nav-item nav-profile dropdown">
              <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="profileDropdown">
                <img src="./assets/images/logo-full.png" alt="profile">
              </a>
              <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
                <span class="dropdown-item disabled">{{ user }}</span>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" routerLink="/pages/users" *ngIf="permission.user > 0 && userType.userTypeId == 1">
                  <i class="icon-settings text-primary mr-2"></i>
                  Users
                </a>
                <a class="dropdown-item" routerLink="/pages/barristers/holidays" *ngIf="permission.holiday > 0">
                  <i class="icon-settings text-primary mr-2"></i>
                  Holidays
                </a>
                <a class="dropdown-item" routerLink="/pages/courts" *ngIf="permission.court > 0 && userType.userTypeId == 1">
                  <i class="icon-settings text-primary mr-2"></i>
                  Courts
                </a>
                <a class="dropdown-item" routerLink="/pages/archieved" *ngIf="permission.archieved > 0 && userType.userTypeId == 1">
                  <i class="icon-settings text-primary mr-2"></i>
                  Archieved
                </a>
                <a class="dropdown-item" routerLink="/pages/settings" *ngIf="permission.setting > 0 && userType.userTypeId == 1">
                  <i class="icon-settings text-primary mr-2"></i>
                  Settings
                </a>
                <a class="dropdown-item" routerLink="/pages/automation" *ngIf="permission.setting > 0 && userType.userTypeId == 1">
                  <i class="icon-settings text-primary mr-2"></i>
                  Automation
                </a>
                <a class="dropdown-item" routerLink="/pages/company" *ngIf="userType.userTypeId == 1">
                  <i class="icon-settings text-primary mr-2"></i>
                  Company
                </a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" (click)="tryLogOut()">
                  <i class="icon-logout text-primary mr-2"></i>
                  Logout
                </a>
              </div>
            </li>
          </ul>

          <!-- Navigation Menu Toggle Button -->
          <button class="navbar-toggler align-self-center ml-2" type="button" (click)="toggleNavMenu()">
            <span class="icon-menu"></span>
          </button>
        </div>
      </div>
    </div>
  </nav>
